module.exports = __webpack_public_path__ + "static/img/1.a020736.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/eng/1.png
// module id = Opgt
// module chunks = 0